/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ActivityCoverage,
  ActivityUpdateResponse,
  BulkActionEnqueuedResponse,
  FoodActivityRecord,
  FoodActivityRecordUpdate,
  FoodActivityRetrieveUpdate,
  FoodAndDrinkPreviewResults,
  InsightsTaxonomyCategory,
  PackagingActivityRecord,
  PackagingActivityRecordUpdate,
  PackagingActivityRetrieve,
  PackagingActivityUpdate,
  PackagingPreviewResults,
  PaginatedFoodActivitiesListList,
  PaginatedFoodActivityRecordList,
  PaginatedPackagingActivitiesListList,
  PaginatedPackagingActivityRecordList,
  PaginatedReviewPurchasedGoodList,
  PaginatedUncategorisedPurchasedGoodList,
  PatchedFoodActivityRecordUpdate,
  PatchedFoodActivityRetrieveUpdate,
  PatchedPackagingActivityRecordUpdate,
  PatchedPackagingActivityUpdate,
  PatchedPurchasedGoodsBulkActionRequest,
  PurchasedGoodItemInsights,
  PurchasedGoodReviewStats,
  PurchasedGoodsFoodInsightsRetrieveParams,
  PurchasedGoodsFoodListParams,
  PurchasedGoodsFoodPreviewRetrieveParams,
  PurchasedGoodsFoodRecordsListParams,
  PurchasedGoodsFoodSpendRetrieveParams,
  PurchasedGoodsInsights,
  PurchasedGoodsInsightsRetrieveParams,
  PurchasedGoodsItem,
  PurchasedGoodsItemsListParams,
  PurchasedGoodsOtherListParams,
  PurchasedGoodsPackagingInsightsRetrieveParams,
  PurchasedGoodsPackagingListParams,
  PurchasedGoodsPackagingPreviewRetrieveParams,
  PurchasedGoodsPackagingRecordsListParams,
  PurchasedGoodsPackagingSpendRetrieveParams,
  PurchasedGoodsReviewListParams,
  PurchasedGoodsSpend,
  PurchasedGoodsTaxonomyListParams
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const purchasedGoodsDestroy = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/purchased-goods/${activityUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getPurchasedGoodsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsDestroy>>, TError,{activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsDestroy>>, TError,{activityUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsDestroy>>, {activityUuid: string}> = (props) => {
          const {activityUuid} = props ?? {};

          return  purchasedGoodsDestroy(activityUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsDestroy>>>
    
    export type PurchasedGoodsDestroyMutationError = unknown

    export const usePurchasedGoodsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsDestroy>>, TError,{activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsDestroy>>,
        TError,
        {activityUuid: string},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsRecordsDestroy = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/purchased-goods/${activityUuid}/records/${recordUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getPurchasedGoodsRecordsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>, {activityUuid: string;recordUuid: string}> = (props) => {
          const {activityUuid,recordUuid} = props ?? {};

          return  purchasedGoodsRecordsDestroy(activityUuid,recordUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsRecordsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>>
    
    export type PurchasedGoodsRecordsDestroyMutationError = unknown

    export const usePurchasedGoodsRecordsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>, TError,{activityUuid: string;recordUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsRecordsDestroy>>,
        TError,
        {activityUuid: string;recordUuid: string},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsRecordsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Enqueue a purchased-goods bulk action.
 */
export const purchasedGoodsBulkPartialUpdate = (
    patchedPurchasedGoodsBulkActionRequest: PatchedPurchasedGoodsBulkActionRequest,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<BulkActionEnqueuedResponse>(
      {url: `/purchased-goods/bulk`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPurchasedGoodsBulkActionRequest
    },
      options);
    }
  


export const getPurchasedGoodsBulkPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>, TError,{data: PatchedPurchasedGoodsBulkActionRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>, TError,{data: PatchedPurchasedGoodsBulkActionRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>, {data: PatchedPurchasedGoodsBulkActionRequest}> = (props) => {
          const {data} = props ?? {};

          return  purchasedGoodsBulkPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsBulkPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>>
    export type PurchasedGoodsBulkPartialUpdateMutationBody = PatchedPurchasedGoodsBulkActionRequest
    export type PurchasedGoodsBulkPartialUpdateMutationError = unknown

    export const usePurchasedGoodsBulkPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>, TError,{data: PatchedPurchasedGoodsBulkActionRequest}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsBulkPartialUpdate>>,
        TError,
        {data: PatchedPurchasedGoodsBulkActionRequest},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsBulkPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsFoodList = (
    params?: PurchasedGoodsFoodListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedFoodActivitiesListList>(
      {url: `/purchased-goods/food`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodListQueryKey = (params?: PurchasedGoodsFoodListParams,) => {
    return [`/purchased-goods/food`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsFoodListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError = unknown>(params?: PurchasedGoodsFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodList>>> = ({ signal, pageParam }) => purchasedGoodsFoodList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodList>>>
export type PurchasedGoodsFoodListInfiniteQueryError = unknown

export const usePurchasedGoodsFoodListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError = unknown>(
 params?: PurchasedGoodsFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError = unknown>(params?: PurchasedGoodsFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodList>>> = ({ signal }) => purchasedGoodsFoodList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodList>>>
export type PurchasedGoodsFoodListQueryError = unknown

export const usePurchasedGoodsFoodList = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError = unknown>(
 params?: PurchasedGoodsFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodRetrieve = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodActivityRetrieveUpdate>(
      {url: `/purchased-goods/food/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodRetrieveQueryKey = (activityUuid: string,) => {
    return [`/purchased-goods/food/${activityUuid}`] as const;
    }

    
export const getPurchasedGoodsFoodRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>> = ({ signal }) => purchasedGoodsFoodRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>>
export type PurchasedGoodsFoodRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRetrieveInfiniteQueryOptions(activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>> = ({ signal }) => purchasedGoodsFoodRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>>
export type PurchasedGoodsFoodRetrieveQueryError = unknown

export const usePurchasedGoodsFoodRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRetrieveQueryOptions(activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodUpdate = (
    activityUuid: string,
    foodActivityRetrieveUpdate: NonReadonly<FoodActivityRetrieveUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<FoodActivityRetrieveUpdate>(
      {url: `/purchased-goods/food/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: foodActivityRetrieveUpdate
    },
      options);
    }
  


export const getPurchasedGoodsFoodUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>, {activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  purchasedGoodsFoodUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsFoodUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>>
    export type PurchasedGoodsFoodUpdateMutationBody = NonReadonly<FoodActivityRetrieveUpdate>
    export type PurchasedGoodsFoodUpdateMutationError = unknown

    export const usePurchasedGoodsFoodUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>, TError,{activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsFoodUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsFoodUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsFoodPartialUpdate = (
    activityUuid: string,
    patchedFoodActivityRetrieveUpdate: NonReadonly<PatchedFoodActivityRetrieveUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<FoodActivityRetrieveUpdate>(
      {url: `/purchased-goods/food/${activityUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFoodActivityRetrieveUpdate
    },
      options);
    }
  


export const getPurchasedGoodsFoodPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodActivityRetrieveUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>, {activityUuid: string;data: NonReadonly<PatchedFoodActivityRetrieveUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  purchasedGoodsFoodPartialUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsFoodPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>>
    export type PurchasedGoodsFoodPartialUpdateMutationBody = NonReadonly<PatchedFoodActivityRetrieveUpdate>
    export type PurchasedGoodsFoodPartialUpdateMutationError = unknown

    export const usePurchasedGoodsFoodPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedFoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsFoodPartialUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PatchedFoodActivityRetrieveUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsFoodPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Totals, previous year, monthly series and suppliers for one item.
 */
export const purchasedGoodsFoodInsightsRetrieve = (
    activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodItemInsights>(
      {url: `/purchased-goods/food/${activityUuid}/insights`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodInsightsRetrieveQueryKey = (activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams,) => {
    return [`/purchased-goods/food/${activityUuid}/insights`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsFoodInsightsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodInsightsRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsFoodInsightsRetrieve(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodInsightsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>>
export type PurchasedGoodsFoodInsightsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodInsightsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodInsightsRetrieveInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodInsightsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodInsightsRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>> = ({ signal }) => purchasedGoodsFoodInsightsRetrieve(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodInsightsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>>
export type PurchasedGoodsFoodInsightsRetrieveQueryError = unknown

export const usePurchasedGoodsFoodInsightsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodInsightsRetrieveQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodRecordsList = (
    activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedFoodActivityRecordList>(
      {url: `/purchased-goods/food/${activityUuid}/records`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodRecordsListQueryKey = (activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams,) => {
    return [`/purchased-goods/food/${activityUuid}/records`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsFoodRecordsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>> = ({ signal, pageParam }) => purchasedGoodsFoodRecordsList(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRecordsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>>
export type PurchasedGoodsFoodRecordsListInfiniteQueryError = unknown

export const usePurchasedGoodsFoodRecordsListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRecordsListInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>> = ({ signal }) => purchasedGoodsFoodRecordsList(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>>
export type PurchasedGoodsFoodRecordsListQueryError = unknown

export const usePurchasedGoodsFoodRecordsList = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRecordsListQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodRecordsRetrieve = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodActivityRecord>(
      {url: `/purchased-goods/food/${activityUuid}/records/${recordUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodRecordsRetrieveQueryKey = (activityUuid: string,
    recordUuid: string,) => {
    return [`/purchased-goods/food/${activityUuid}/records/${recordUuid}`] as const;
    }

    
export const getPurchasedGoodsFoodRecordsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>> = ({ signal }) => purchasedGoodsFoodRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRecordsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>>
export type PurchasedGoodsFoodRecordsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodRecordsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRecordsRetrieveInfiniteQueryOptions(activityUuid,recordUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>> = ({ signal }) => purchasedGoodsFoodRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>>
export type PurchasedGoodsFoodRecordsRetrieveQueryError = unknown

export const usePurchasedGoodsFoodRecordsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodRecordsRetrieveQueryOptions(activityUuid,recordUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodRecordsUpdate = (
    activityUuid: string,
    recordUuid: string,
    foodActivityRecordUpdate: NonReadonly<FoodActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/purchased-goods/food/${activityUuid}/records/${recordUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: foodActivityRecordUpdate
    },
      options);
    }
  


export const getPurchasedGoodsFoodRecordsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  purchasedGoodsFoodRecordsUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsFoodRecordsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>>
    export type PurchasedGoodsFoodRecordsUpdateMutationBody = NonReadonly<FoodActivityRecordUpdate>
    export type PurchasedGoodsFoodRecordsUpdateMutationError = unknown

    export const usePurchasedGoodsFoodRecordsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsFoodRecordsUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<FoodActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsFoodRecordsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsFoodRecordsPartialUpdate = (
    activityUuid: string,
    recordUuid: string,
    patchedFoodActivityRecordUpdate: NonReadonly<PatchedFoodActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/purchased-goods/food/${activityUuid}/records/${recordUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedFoodActivityRecordUpdate
    },
      options);
    }
  


export const getPurchasedGoodsFoodRecordsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  purchasedGoodsFoodRecordsPartialUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsFoodRecordsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>>
    export type PurchasedGoodsFoodRecordsPartialUpdateMutationBody = NonReadonly<PatchedFoodActivityRecordUpdate>
    export type PurchasedGoodsFoodRecordsPartialUpdateMutationError = unknown

    export const usePurchasedGoodsFoodRecordsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsFoodRecordsPartialUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedFoodActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsFoodRecordsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Return spend analytics for the activity.
 */
export const purchasedGoodsFoodSpendRetrieve = (
    activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodsSpend>(
      {url: `/purchased-goods/food/${activityUuid}/spend`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodSpendRetrieveQueryKey = (activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams,) => {
    return [`/purchased-goods/food/${activityUuid}/spend`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsFoodSpendRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodSpendRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsFoodSpendRetrieve(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodSpendRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>>
export type PurchasedGoodsFoodSpendRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodSpendRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodSpendRetrieveInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodSpendRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodSpendRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>> = ({ signal }) => purchasedGoodsFoodSpendRetrieve(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodSpendRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>>
export type PurchasedGoodsFoodSpendRetrieveQueryError = unknown

export const usePurchasedGoodsFoodSpendRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsFoodSpendRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodSpendRetrieveQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodCoverageRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityCoverage>(
      {url: `/purchased-goods/food/coverage`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodCoverageRetrieveQueryKey = () => {
    return [`/purchased-goods/food/coverage`] as const;
    }

    
export const getPurchasedGoodsFoodCoverageRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>> = ({ signal }) => purchasedGoodsFoodCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodCoverageRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>>
export type PurchasedGoodsFoodCoverageRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodCoverageRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodCoverageRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodCoverageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>> = ({ signal }) => purchasedGoodsFoodCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodCoverageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>>
export type PurchasedGoodsFoodCoverageRetrieveQueryError = unknown

export const usePurchasedGoodsFoodCoverageRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodCoverageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsFoodPreviewRetrieve = (
    params?: PurchasedGoodsFoodPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodAndDrinkPreviewResults>(
      {url: `/purchased-goods/food/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsFoodPreviewRetrieveQueryKey = (params?: PurchasedGoodsFoodPreviewRetrieveParams,) => {
    return [`/purchased-goods/food/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsFoodPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError = unknown>(params?: PurchasedGoodsFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsFoodPreviewRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>>
export type PurchasedGoodsFoodPreviewRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsFoodPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodPreviewRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsFoodPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError = unknown>(params?: PurchasedGoodsFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsFoodPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>> = ({ signal }) => purchasedGoodsFoodPreviewRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsFoodPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>>
export type PurchasedGoodsFoodPreviewRetrieveQueryError = unknown

export const usePurchasedGoodsFoodPreviewRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsFoodPreviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Aggregated purchased goods insights: totals, emissions time-series, and groupBy breakdown.
 */
export const purchasedGoodsInsightsRetrieve = (
    params?: PurchasedGoodsInsightsRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodsInsights>(
      {url: `/purchased-goods/insights`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsInsightsRetrieveQueryKey = (params?: PurchasedGoodsInsightsRetrieveParams,) => {
    return [`/purchased-goods/insights`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsInsightsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError = unknown>(params?: PurchasedGoodsInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsInsightsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsInsightsRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsInsightsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>>
export type PurchasedGoodsInsightsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsInsightsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsInsightsRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsInsightsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError = unknown>(params?: PurchasedGoodsInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsInsightsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>> = ({ signal }) => purchasedGoodsInsightsRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsInsightsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>>
export type PurchasedGoodsInsightsRetrieveQueryError = unknown

export const usePurchasedGoodsInsightsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsInsightsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Purchased goods selectable as a filter on the insights endpoint.

Unpaginated: a plain array, capped at PurchasedGoodsItemService.MAX_ITEMS. The
dimension params are view columns, so the filterset only validates them and the
service applies them; ``item`` and ``search`` match Activity and are applied here.
 */
export const purchasedGoodsItemsList = (
    params?: PurchasedGoodsItemsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodsItem[]>(
      {url: `/purchased-goods/items`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsItemsListQueryKey = (params?: PurchasedGoodsItemsListParams,) => {
    return [`/purchased-goods/items`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsItemsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError = unknown>(params?: PurchasedGoodsItemsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsItemsList>>> = ({ signal, pageParam }) => purchasedGoodsItemsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsItemsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsItemsList>>>
export type PurchasedGoodsItemsListInfiniteQueryError = unknown

export const usePurchasedGoodsItemsListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError = unknown>(
 params?: PurchasedGoodsItemsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsItemsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsItemsListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError = unknown>(params?: PurchasedGoodsItemsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsItemsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsItemsList>>> = ({ signal }) => purchasedGoodsItemsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsItemsListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsItemsList>>>
export type PurchasedGoodsItemsListQueryError = unknown

export const usePurchasedGoodsItemsList = <TData = Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError = unknown>(
 params?: PurchasedGoodsItemsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsItemsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsItemsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List Other purchased goods — the out-of-scope page.

A thin specialisation of the food / packaging activity list pinned to the
``other-purchased-goods`` activity type and ``item_type=other``. It reuses
the parent's record-based facet filtering, facet-aware aggregation and
``sort`` ordering wholesale. Uncertain-typed goods are NOT served here —
they belong to the review endpoint with the rest of the review queue.
 */
export const purchasedGoodsOtherList = (
    params?: PurchasedGoodsOtherListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedUncategorisedPurchasedGoodList>(
      {url: `/purchased-goods/other`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsOtherListQueryKey = (params?: PurchasedGoodsOtherListParams,) => {
    return [`/purchased-goods/other`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsOtherListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError = unknown>(params?: PurchasedGoodsOtherListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsOtherListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsOtherList>>> = ({ signal, pageParam }) => purchasedGoodsOtherList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsOtherListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsOtherList>>>
export type PurchasedGoodsOtherListInfiniteQueryError = unknown

export const usePurchasedGoodsOtherListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError = unknown>(
 params?: PurchasedGoodsOtherListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsOtherListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsOtherListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError = unknown>(params?: PurchasedGoodsOtherListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsOtherListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsOtherList>>> = ({ signal }) => purchasedGoodsOtherList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsOtherListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsOtherList>>>
export type PurchasedGoodsOtherListQueryError = unknown

export const usePurchasedGoodsOtherList = <TData = Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError = unknown>(
 params?: PurchasedGoodsOtherListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsOtherList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsOtherListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingList = (
    params?: PurchasedGoodsPackagingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedPackagingActivitiesListList>(
      {url: `/purchased-goods/packaging`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingListQueryKey = (params?: PurchasedGoodsPackagingListParams,) => {
    return [`/purchased-goods/packaging`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsPackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError = unknown>(params?: PurchasedGoodsPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>> = ({ signal, pageParam }) => purchasedGoodsPackagingList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>>
export type PurchasedGoodsPackagingListInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError = unknown>(
 params?: PurchasedGoodsPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError = unknown>(params?: PurchasedGoodsPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>> = ({ signal }) => purchasedGoodsPackagingList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>>
export type PurchasedGoodsPackagingListQueryError = unknown

export const usePurchasedGoodsPackagingList = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError = unknown>(
 params?: PurchasedGoodsPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingRetrieve = (
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingActivityRetrieve>(
      {url: `/purchased-goods/packaging/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingRetrieveQueryKey = (activityUuid: string,) => {
    return [`/purchased-goods/packaging/${activityUuid}`] as const;
    }

    
export const getPurchasedGoodsPackagingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>> = ({ signal }) => purchasedGoodsPackagingRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>>
export type PurchasedGoodsPackagingRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRetrieveInfiniteQueryOptions(activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError = unknown>(activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRetrieveQueryKey(activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>> = ({ signal }) => purchasedGoodsPackagingRetrieve(activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>>
export type PurchasedGoodsPackagingRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError = unknown>(
 activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRetrieveQueryOptions(activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingUpdate = (
    activityUuid: string,
    packagingActivityUpdate: NonReadonly<PackagingActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingActivityUpdate>(
      {url: `/purchased-goods/packaging/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingActivityUpdate
    },
      options);
    }
  


export const getPurchasedGoodsPackagingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>, {activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  purchasedGoodsPackagingUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsPackagingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>>
    export type PurchasedGoodsPackagingUpdateMutationBody = NonReadonly<PackagingActivityUpdate>
    export type PurchasedGoodsPackagingUpdateMutationError = unknown

    export const usePurchasedGoodsPackagingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>, TError,{activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsPackagingUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PackagingActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsPackagingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsPackagingPartialUpdate = (
    activityUuid: string,
    patchedPackagingActivityUpdate: NonReadonly<PatchedPackagingActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PackagingActivityUpdate>(
      {url: `/purchased-goods/packaging/${activityUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPackagingActivityUpdate
    },
      options);
    }
  


export const getPurchasedGoodsPackagingPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>, {activityUuid: string;data: NonReadonly<PatchedPackagingActivityUpdate>}> = (props) => {
          const {activityUuid,data} = props ?? {};

          return  purchasedGoodsPackagingPartialUpdate(activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsPackagingPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>>
    export type PurchasedGoodsPackagingPartialUpdateMutationBody = NonReadonly<PatchedPackagingActivityUpdate>
    export type PurchasedGoodsPackagingPartialUpdateMutationError = unknown

    export const usePurchasedGoodsPackagingPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>, TError,{activityUuid: string;data: NonReadonly<PatchedPackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsPackagingPartialUpdate>>,
        TError,
        {activityUuid: string;data: NonReadonly<PatchedPackagingActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsPackagingPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Totals, previous year, monthly series and suppliers for one item.
 */
export const purchasedGoodsPackagingInsightsRetrieve = (
    activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodItemInsights>(
      {url: `/purchased-goods/packaging/${activityUuid}/insights`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingInsightsRetrieveQueryKey = (activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams,) => {
    return [`/purchased-goods/packaging/${activityUuid}/insights`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsPackagingInsightsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingInsightsRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsPackagingInsightsRetrieve(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingInsightsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>>
export type PurchasedGoodsPackagingInsightsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingInsightsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingInsightsRetrieveInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingInsightsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingInsightsRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>> = ({ signal }) => purchasedGoodsPackagingInsightsRetrieve(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingInsightsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>>
export type PurchasedGoodsPackagingInsightsRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingInsightsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingInsightsRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingInsightsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingInsightsRetrieveQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingRecordsList = (
    activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedPackagingActivityRecordList>(
      {url: `/purchased-goods/packaging/${activityUuid}/records`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingRecordsListQueryKey = (activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams,) => {
    return [`/purchased-goods/packaging/${activityUuid}/records`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsPackagingRecordsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>> = ({ signal, pageParam }) => purchasedGoodsPackagingRecordsList(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRecordsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>>
export type PurchasedGoodsPackagingRecordsListInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingRecordsListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRecordsListInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingRecordsListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRecordsListQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>> = ({ signal }) => purchasedGoodsPackagingRecordsList(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRecordsListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>>
export type PurchasedGoodsPackagingRecordsListQueryError = unknown

export const usePurchasedGoodsPackagingRecordsList = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingRecordsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRecordsListQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingRecordsRetrieve = (
    activityUuid: string,
    recordUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingActivityRecord>(
      {url: `/purchased-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingRecordsRetrieveQueryKey = (activityUuid: string,
    recordUuid: string,) => {
    return [`/purchased-goods/packaging/${activityUuid}/records/${recordUuid}`] as const;
    }

    
export const getPurchasedGoodsPackagingRecordsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>> = ({ signal }) => purchasedGoodsPackagingRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRecordsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>>
export type PurchasedGoodsPackagingRecordsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingRecordsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRecordsRetrieveInfiniteQueryOptions(activityUuid,recordUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingRecordsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError = unknown>(activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingRecordsRetrieveQueryKey(activityUuid,recordUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>> = ({ signal }) => purchasedGoodsPackagingRecordsRetrieve(activityUuid,recordUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid && recordUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingRecordsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>>
export type PurchasedGoodsPackagingRecordsRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingRecordsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError = unknown>(
 activityUuid: string,
    recordUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingRecordsRetrieveQueryOptions(activityUuid,recordUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingRecordsUpdate = (
    activityUuid: string,
    recordUuid: string,
    packagingActivityRecordUpdate: NonReadonly<PackagingActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/purchased-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingActivityRecordUpdate
    },
      options);
    }
  


export const getPurchasedGoodsPackagingRecordsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PackagingActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  purchasedGoodsPackagingRecordsUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsPackagingRecordsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>>
    export type PurchasedGoodsPackagingRecordsUpdateMutationBody = NonReadonly<PackagingActivityRecordUpdate>
    export type PurchasedGoodsPackagingRecordsUpdateMutationError = unknown

    export const usePurchasedGoodsPackagingRecordsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PackagingActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PackagingActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsPackagingRecordsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const purchasedGoodsPackagingRecordsPartialUpdate = (
    activityUuid: string,
    recordUuid: string,
    patchedPackagingActivityRecordUpdate: NonReadonly<PatchedPackagingActivityRecordUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/purchased-goods/packaging/${activityUuid}/records/${recordUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPackagingActivityRecordUpdate
    },
      options);
    }
  


export const getPurchasedGoodsPackagingRecordsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingActivityRecordUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>, {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingActivityRecordUpdate>}> = (props) => {
          const {activityUuid,recordUuid,data} = props ?? {};

          return  purchasedGoodsPackagingRecordsPartialUpdate(activityUuid,recordUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PurchasedGoodsPackagingRecordsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>>
    export type PurchasedGoodsPackagingRecordsPartialUpdateMutationBody = NonReadonly<PatchedPackagingActivityRecordUpdate>
    export type PurchasedGoodsPackagingRecordsPartialUpdateMutationError = unknown

    export const usePurchasedGoodsPackagingRecordsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>, TError,{activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingActivityRecordUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof purchasedGoodsPackagingRecordsPartialUpdate>>,
        TError,
        {activityUuid: string;recordUuid: string;data: NonReadonly<PatchedPackagingActivityRecordUpdate>},
        TContext
      > => {

      const mutationOptions = getPurchasedGoodsPackagingRecordsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Return spend analytics for the activity.
 */
export const purchasedGoodsPackagingSpendRetrieve = (
    activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodsSpend>(
      {url: `/purchased-goods/packaging/${activityUuid}/spend`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingSpendRetrieveQueryKey = (activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams,) => {
    return [`/purchased-goods/packaging/${activityUuid}/spend`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsPackagingSpendRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingSpendRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsPackagingSpendRetrieve(activityUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingSpendRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>>
export type PurchasedGoodsPackagingSpendRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingSpendRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingSpendRetrieveInfiniteQueryOptions(activityUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingSpendRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError = unknown>(activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingSpendRetrieveQueryKey(activityUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>> = ({ signal }) => purchasedGoodsPackagingSpendRetrieve(activityUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingSpendRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>>
export type PurchasedGoodsPackagingSpendRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingSpendRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError = unknown>(
 activityUuid: string,
    params?: PurchasedGoodsPackagingSpendRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingSpendRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingSpendRetrieveQueryOptions(activityUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingCoverageRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityCoverage>(
      {url: `/purchased-goods/packaging/coverage`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingCoverageRetrieveQueryKey = () => {
    return [`/purchased-goods/packaging/coverage`] as const;
    }

    
export const getPurchasedGoodsPackagingCoverageRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>> = ({ signal }) => purchasedGoodsPackagingCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingCoverageRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>>
export type PurchasedGoodsPackagingCoverageRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingCoverageRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingCoverageRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingCoverageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingCoverageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>> = ({ signal }) => purchasedGoodsPackagingCoverageRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingCoverageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>>
export type PurchasedGoodsPackagingCoverageRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingCoverageRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingCoverageRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingCoverageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const purchasedGoodsPackagingPreviewRetrieve = (
    params?: PurchasedGoodsPackagingPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingPreviewResults>(
      {url: `/purchased-goods/packaging/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsPackagingPreviewRetrieveQueryKey = (params?: PurchasedGoodsPackagingPreviewRetrieveParams,) => {
    return [`/purchased-goods/packaging/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsPackagingPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError = unknown>(params?: PurchasedGoodsPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>> = ({ signal, pageParam }) => purchasedGoodsPackagingPreviewRetrieve({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>>
export type PurchasedGoodsPackagingPreviewRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsPackagingPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingPreviewRetrieveInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsPackagingPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError = unknown>(params?: PurchasedGoodsPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsPackagingPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>> = ({ signal }) => purchasedGoodsPackagingPreviewRetrieve(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsPackagingPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>>
export type PurchasedGoodsPackagingPreviewRetrieveQueryError = unknown

export const usePurchasedGoodsPackagingPreviewRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError = unknown>(
 params?: PurchasedGoodsPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsPackagingPreviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List purchased goods needing review — the Items for review page.

The full review population, one row per item with a single derived reason:
``unclear_item_type`` (item_type uncertain), ``unclear_match`` and
``unclear_weight`` (the review flags). All are withheld from reporting and
from the food / packaging lists until resolved. The optional
``review_reason`` facet filters by the derived reason, honouring
precedence: an item with both flags surfaces as ``unclear_match`` only.

Mixed activity types under the hood: flagged goods are food activities,
uncertain goods are zero-emission ``other-purchased-goods`` activities —
hence the Coalesce quantity expression (food records carry
``total_quantity``, other records carry ``quantity``).
 */
export const purchasedGoodsReviewList = (
    params?: PurchasedGoodsReviewListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedReviewPurchasedGoodList>(
      {url: `/purchased-goods/review`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsReviewListQueryKey = (params?: PurchasedGoodsReviewListParams,) => {
    return [`/purchased-goods/review`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsReviewListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError = unknown>(params?: PurchasedGoodsReviewListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsReviewListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsReviewList>>> = ({ signal, pageParam }) => purchasedGoodsReviewList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsReviewListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsReviewList>>>
export type PurchasedGoodsReviewListInfiniteQueryError = unknown

export const usePurchasedGoodsReviewListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError = unknown>(
 params?: PurchasedGoodsReviewListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsReviewListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsReviewListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError = unknown>(params?: PurchasedGoodsReviewListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsReviewListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsReviewList>>> = ({ signal }) => purchasedGoodsReviewList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsReviewListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsReviewList>>>
export type PurchasedGoodsReviewListQueryError = unknown

export const usePurchasedGoodsReviewList = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError = unknown>(
 params?: PurchasedGoodsReviewListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsReviewListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * High-level purchased-goods counts for the Excluded items hub.

One number per category — Other (out of scope) and the review queue split
by derived reason — so the hub can render badges and tab counts without
fetching any list.
 */
export const purchasedGoodsReviewStatsRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PurchasedGoodReviewStats>(
      {url: `/purchased-goods/review/stats`, method: 'GET', signal
    },
      options);
    }
  

export const getPurchasedGoodsReviewStatsRetrieveQueryKey = () => {
    return [`/purchased-goods/review/stats`] as const;
    }

    
export const getPurchasedGoodsReviewStatsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsReviewStatsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>> = ({ signal }) => purchasedGoodsReviewStatsRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsReviewStatsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>>
export type PurchasedGoodsReviewStatsRetrieveInfiniteQueryError = unknown

export const usePurchasedGoodsReviewStatsRetrieveInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsReviewStatsRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsReviewStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsReviewStatsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>> = ({ signal }) => purchasedGoodsReviewStatsRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsReviewStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>>
export type PurchasedGoodsReviewStatsRetrieveQueryError = unknown

export const usePurchasedGoodsReviewStatsRetrieve = <TData = Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsReviewStatsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsReviewStatsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The available taxonomy as category > subcategory > base product.
 */
export const purchasedGoodsTaxonomyList = (
    params?: PurchasedGoodsTaxonomyListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<InsightsTaxonomyCategory[]>(
      {url: `/purchased-goods/taxonomy`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPurchasedGoodsTaxonomyListQueryKey = (params?: PurchasedGoodsTaxonomyListParams,) => {
    return [`/purchased-goods/taxonomy`, ...(params ? [params]: [])] as const;
    }

    
export const getPurchasedGoodsTaxonomyListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError = unknown>(params?: PurchasedGoodsTaxonomyListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsTaxonomyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>> = ({ signal, pageParam }) => purchasedGoodsTaxonomyList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsTaxonomyListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>>
export type PurchasedGoodsTaxonomyListInfiniteQueryError = unknown

export const usePurchasedGoodsTaxonomyListInfinite = <TData = Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError = unknown>(
 params?: PurchasedGoodsTaxonomyListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsTaxonomyListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPurchasedGoodsTaxonomyListQueryOptions = <TData = Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError = unknown>(params?: PurchasedGoodsTaxonomyListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchasedGoodsTaxonomyListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>> = ({ signal }) => purchasedGoodsTaxonomyList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData> & { queryKey: QueryKey }
}

export type PurchasedGoodsTaxonomyListQueryResult = NonNullable<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>>
export type PurchasedGoodsTaxonomyListQueryError = unknown

export const usePurchasedGoodsTaxonomyList = <TData = Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError = unknown>(
 params?: PurchasedGoodsTaxonomyListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof purchasedGoodsTaxonomyList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPurchasedGoodsTaxonomyListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



